import React, { useState } from "react";
import { FaMicrophoneAlt } from "react-icons/fa";
import SpeechtoText from "./SpeechtoText";
import "./css/VoiceInput.css";
import CustomNodeFlow from "./CustomNodeFlow";

const VoiceInput = () => {
  const [textInput, setTextInput] = useState("");
  const { isListening, transcript, startListening, stopListening } =
    SpeechtoText({ continuous: true });

  const startStopListening = () => {
    isListening ? stopVoiceInput() : startListening();
  };

  const stopVoiceInput = () => {
    setTextInput(
      (prevVal) =>
        prevVal +
        (transcript.length ? (prevVal.length ? " " : "") + transcript : "")
    );

    stopListening();
  };

  return (
    <div>
      <div>
        <FaMicrophoneAlt
          id="mic"
          onMouseDown={() => {
            startStopListening();
          }}
          onMouseUp={() => {
            startStopListening();
          }}
          color="#383838"
        />
        <br />
        <div
          style={{
            color: "#383838",
            backgroundColor: "transparent",
            fontSize: "18px",
          }}
        >
          Click and hold mic to record
        </div>
      </div>
    </div>
  );
};
export default VoiceInput;
